// extracted by mini-css-extract-plugin
export default {"modal-container":"loading-modal_modal-container__LvRmv","content":"loading-modal_content__UJ4fw"};